// extracted by mini-css-extract-plugin
module.exports = {"card":"f0eEP","icon":"wGQpT","title":"xQpBD","theme_primary":"iou5t","theme_secondary":"e6a8j","theme_tertiary":"_3axFc","theme_quaternary":"NhumJ"};